import { default as classnames } from 'classnames';
import { pull } from 'lodash';
import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { twMerge } from 'tailwind-merge';

type FormCheckboxGroupProps = FieldRenderProps<string, HTMLElement, string> & {
  options: { label: string; value: string }[];
  onGroupChange?: (value: string[]) => void;
  labelClassName?: string;
};

const FormCheckboxGroup: FC<FormCheckboxGroupProps> = ({
  options,
  input,
  meta: { touched, error },
  disabled,
  onGroupChange,
  labelText,
  labelClassName,
  ...otherProps
}) => (
  <>
    {labelText && (
      <label className={twMerge('text-sm text-primaryGray', labelClassName)}>
        {labelText}
      </label>
    )}
    {options.map(({ label, value }) => {
      return (
        <div className="block" key={value} {...otherProps}>
          <div className="">
            <label
              htmlFor={`${value}-checkbox`}
              className={classnames('inline-flex items-center', {
                'sr-only': !label,
              })}
            >
              <input
                id={`${value}-checkbox`}
                type="checkbox"
                className={classnames(
                  'size-4 rounded border-gray-300 text-sky-900 focus:ring-2 focus:ring-sky-800',
                  {
                    'border-red-800': touched && error,
                  },
                )}
                autoComplete="off"
                value={value}
                checked={input.value.includes(value)}
                disabled={disabled}
                onChange={(e) => {
                  const newValue = Array.from(input.value);

                  if (e.target.checked) {
                    newValue.push(value);
                  } else {
                    pull(newValue, value);
                  }

                  // Callback for when we need to monitor the whole group update
                  onGroupChange?.(newValue);

                  return input.onChange(newValue);
                }}
              />
              <span
                className={classnames('ml-2 text-sm', {
                  'opacity-50': disabled,
                })}
              >
                {label}
              </span>
            </label>
          </div>
        </div>
      );
    })}
    {touched && error && <span className="text-xs text-red-800">{error}</span>}
  </>
);

export default FormCheckboxGroup;
